import DOMPurify from 'dompurify';
import { DESC_ALLOWED_TAGS, DESC_ALLOWED_ATTR, enforceImgSrc } from '@/utils/descriptionSanitize';

/**
 * Render sanitized HTML safely.
 *
 * Allowed tags: same as the description editor (prose + img).
 * img src is restricted to paths containing /web/image/ — any other src is
 * silently removed. This matches the RichDescriptionEditor + server config so
 * Odoo-hosted screenshots are visible while arbitrary remote images are blocked.
 */
export function SafeHtml({ html, className }: { html: string; className?: string }) {
  const sanitized = sanitizeForDisplay(html);
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}

function sanitizeForDisplay(html: string): string {
  DOMPurify.addHook('afterSanitizeAttributes', enforceImgSrc);
  const result = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: DESC_ALLOWED_TAGS,
    ALLOWED_ATTR: DESC_ALLOWED_ATTR,
  });
  DOMPurify.removeHook('afterSanitizeAttributes');
  return result;
}
